'use client';

export function CTABanner() {
  return (
    <section className="relative bg-slate-950 py-16 lg:py-20 overflow-hidden">
      {/* Top accent */}
      <div className="absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-amber-600 via-amber-400 to-orange-500" />

      {/* Background video overlay */}
      <div className="absolute inset-0 z-0">
        <video
          src="/videos/CTA.mp4"
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-full object-cover opacity-10"
        />
      </div>

      {/* Subtle grid */}
      

      <div className="relative z-10 max-w-5xl mx-auto px-6 lg:px-12 text-center">
        <div className="flex items-center justify-center gap-2 mb-4">
          <div className="h-px w-8 bg-amber-500" />
          <span className="text-amber-400 text-xs font-semibold tracking-[0.2em] uppercase">Get Started Today</span>
          <div className="h-px w-8 bg-amber-500" />
        </div>

        <h2
          className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight mb-4"
          style={{ fontFamily: "'Sora', sans-serif" }}
        >
          Ready to Build Something{' '}
          <span
            style={{
              background: 'linear-gradient(135deg, #f59e0b, #fb923c)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            Extraordinary?
          </span>
        </h2>

        <p className="text-slate-300 text-base sm:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
          Join 2000+ Indian businesses that trust Farsight Solutions for their registration, compliance, funding and growth needs. Book your free consultation now.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-10">
          <a
            href="/contact"
            className="group inline-flex items-center gap-2 px-8 py-4 rounded-sm font-semibold text-sm text-white tracking-wide transition-all duration-300 hover:shadow-xl hover:shadow-amber-500/30 hover:-translate-y-0.5"
            style={{ background: 'linear-gradient(135deg, #d97706, #f59e0b)' }}
          >
            Book Free Consultation
            <span className="group-hover:translate-x-1 transition-transform">→</span>
          </a>
          <a
            href="tel:+919999999999"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-sm font-semibold text-sm text-white border border-white/20 bg-white/5 backdrop-blur-sm hover:border-white/40 hover:bg-white/10 transition-all duration-300"
          >
            Call Us Now
          </a>
        </div>

        {/* Trust items */}
        <div className="flex flex-wrap items-center justify-center gap-6 text-slate-400 text-xs">
          {[
            'No upfront commitment',
            '24-hr response guarantee',
            'Dedicated account manager',
            'Pan-India service',
          ].map((item) => (
            <div key={item} className="flex items-center gap-1.5">
              <span className="w-1.5 h-1.5 rounded-full bg-amber-400 flex-shrink-0" />
              {item}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}